import React from 'react';
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import './BlogHome.css';
import bloghomebanner from './../../../assets/images/blogs/DeWatermark.ai_1752732805176.jpeg'
import blogData from  './BlogData.js';
import favicon from "./../../../assets/images/favicon.ico"

const BlogHome = () => {
  const navigate = useNavigate();
   useEffect(() => {
       document.title = "Health & Wellness Blog | Dental, Skin, Hair & Homeopathy Tips – hcura";
       const metaDescription = document.querySelector("meta[name='description']");
       if (metaDescription) {
         metaDescription.setAttribute(
           "content",
           "Read expert blogs from hcura Multispeciality Clinic on dental care, skin & hair treatments, and homoeopathy tips. Stay informed and keep your family healthy!"
         );
       }
       const metaKeywords = document.querySelector("meta[name='keywords']");
       if (metaKeywords) {
         metaKeywords.setAttribute(
           "content",
           "health care blog, dental care tips, skin treatment blog, hair care blog, homoeopathy treatment blog, health and wellness blog, cavity prevention tips, acne treatment blogs, hair fall solutions, homoeopathy for chronic diseases, Bangalore clinic blogs, Chennai health tips"
         );
       }
        // Set canonical link
        const existingCanonical = document.querySelector("link[rel='canonical']");
        if (existingCanonical) {
          existingCanonical.setAttribute("href", "https://www.h-cura.com/blog/");
        } else {
          const canonicalLink = document.createElement("link");
          canonicalLink.setAttribute("rel", "canonical");
          canonicalLink.setAttribute("href", "https://www.h-cura.com/blog/");
          document.head.appendChild(canonicalLink);
        }
        // Set favicon
     const existingFavicon = document.querySelector("link[rel='icon']");
     if (existingFavicon) {
       existingFavicon.setAttribute("href", favicon);
     } else {
       const faviconLink = document.createElement("link");
       faviconLink.setAttribute("rel", "icon");
       faviconLink.setAttribute("type", "image/x-icon");
       faviconLink.setAttribute("href", favicon);
       document.head.appendChild(faviconLink);
     }
     }, []);

  useEffect(() => {
    const scriptBlog = document.createElement("script");
    scriptBlog.type = "application/ld+json";
    scriptBlog.innerHTML = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Blog",
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": "https://www.h-cura.com/blog"
      },
      "headline": "Health & Wellness Blog | Dental, Skin, Hair & Homeopathy Tips – H-Cura",
      "description": "Read expert blogs from H-Cura Multispeciality Clinic on dental care, skin & hair treatments, and homeopathy tips. Stay informed and keep your family healthy!",
      "url": "https://www.h-cura.com/blog",
      "publisher": {
        "@type": "Organization",
        "name": "H-Cura Multispeciality Clinic",
        "logo": {
          "@type": "ImageObject",
          "url": "https://www.h-cura.com/static/logo.png"
        }
      },
      
    });

    document.head.appendChild(scriptBlog);

    // Cleanup on unmount
    return () => {
      document.head.removeChild(scriptBlog);
    };
  }, []);
  return (
    <>
      <div className="bloghome">
        {/* Banner Section */}
        <div className="bloghome-banner">
          <img
            src={bloghomebanner} // Replace with your actual banner image path
            alt="Health Tips Banner"
            className="bloghome-banner-image"
          />
          <div className="bloghome-banner-content">
            <h1>Welcome to Our Health Blog/News</h1>
            <p>Explore tips, insights, and updates on healthcare and holistic healing.</p>
          </div>
        </div>

         {/* Blog Cards Section */}
        <div className="bloghome-cards">
          {blogData.map((blog) => (
            <div key={blog.id} className="bloghome-card">
              <img src={blog.image} alt={blog.title} className="bloghome-card-img" />
              <div className="bloghome-card-body">
                <span className="bloghome-card-date">{blog.date}</span>
                <h3 className="bloghome-card-title">{blog.title}</h3>
                <p className="bloghome-card-desc">{blog.content}</p>
                <button
                  className="bloghome-readmore"
                  onClick={() => navigate(`${blog.slug}`)}
                >
                  Read More →
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default BlogHome;
